import React from 'react';
import { useIntl } from 'umi';
import EChartCommon from '@/pages/opinion/components/EChartCommon';
import { NO_DATE, chartAllColors } from '@/pages/opinion/constants';
import { formatChartParamsDate } from '@/pages/opinion/components/ChartCommon/formatter';
import { percentageFormat, reviewsFormat } from '@/pages/opinion/utils/value';
import { getPercentageInfo, mathFormat } from '@/pages/opinion/utils';
import { dealwithTitle, sortLegend } from '../../utils';

export default function PieEchart({
  chartData,
  height = 300,
  pieLabelAlignTo,
}: any) {
  const { formatMessage } = useIntl();
  const eChartsRef = React.useRef(null as any);

  const legendData: Array<any> = [];
  let mentionsTotal = 0;
  chartData?.sort(sortLegend('key', false));
  const newCharData = chartData?.map(
    (v: { key: string; count: number }, index: number) => {
      let name = v.key;
      const color = chartAllColors[index];
      legendData.push({
        name,
        icon: 'circle',
        itemStyle: { color: color },
      });
      mentionsTotal += v.count || 0;
      return {
        ...v,
        value: v.count,
        name: name,
        itemStyle: { color: color },
      };
    },
  );
  const options = {
    legend: {
      data: legendData,
      formatter: (name: string) => {
        return dealwithTitle(name);
      },
    },
    tooltip: {
      borderWidth: 0,
      borderRadius: 6,
      padding: 0,
      formatter: (params: any) => {
        const title = formatMessage({
          id: 'Mentions' || NO_DATE.EMPTY,
        });
        const config = formatChartParamsDate({
          title: title,
          params: params,
          valueFormat: (value, element) => {
            let percentage = percentageFormat(element?.data?.rate * 100);
            percentage =
              percentage === '-'
                ? getPercentageInfo(value, mentionsTotal, 2)
                : percentage;
            return `${reviewsFormat(value)}(${percentage})`;
          },
          listTitleFunc: (item) => item.name + 'h',
        });
        return config;
      },
    },
    title: [
      {
        text: '{name|' + reviewsFormat(mentionsTotal) + '}',
        top: '45%',
        left: 'center',
        textStyle: {
          rich: {
            name: {
              fontSize: 24,
              fontFamily: 'num-m',
              color: '#000000',
              padding: [10, 0],
            },
          },
        },
      },
    ],
    series: [
      {
        labelLayout: (params: any) => {
          const isLeft =
            params.labelRect.x <
            eChartsRef?.current?.getEchartsInstance?.()?.getWidth() / 2;
          const points = params.labelLinePoints;
          points[2][0] = isLeft
            ? params.labelRect.x
            : params.labelRect.x + params.labelRect.width;
          return {
            labelLinePoints: points,
          };
        },
        data: newCharData || [],
        label: {
          color: 'auto',
          alignTo: pieLabelAlignTo,
          formatter: (params: any) => {
            return `{value| ${dealwithTitle(params.name)}}:{a|${mathFormat(
              params.value,
            )}(${params.percent.toFixed(2)}%)}\n{hr|}\n{a|}`;
          },
          edgeDistance: 10,
          rich: {
            a: {
              // color: '#999',
              lineHeight: 20, //设置最后一行空数据高度，为了能让延长线与hr线对接起来
              align: 'center',
            },
            hr: {
              //设置hr是为了让中间线能够自适应长度
              borderColor: 'auto', //hr的颜色为auto时候会主动显示颜色的
              width: '105%',
              borderWidth: 0.5,
              height: 0.5,
            },
            per: {
              //用百分比数据来调整下数字位置，显的好看些。如果不设置，formatter最后一行的空数据就不需要
              padding: [4, 0],
            },
          },
        },
      },
    ],
  };

  return (
    <EChartCommon
      empty={mentionsTotal === 0}
      optionsProps={{
        type: 'pie',
        pieLabelAlignTo: pieLabelAlignTo || 'edge',
      }}
      ref={eChartsRef}
      options={options}
      height={height}
    />
  );
}
